import React, {Fragment, useContext} from 'react';
import {graphql, StaticQuery} from 'gatsby';

// contexts
import LocaleContext from '../../LocaleContext';

// components
import LocalizedLink from '../LocalizedLink/LocalizedLink';

// helpers
import { getLocalizedPropertyByPrefix } from '../../helpers/localeHelpers';

// styles
import './main-menu.scss';

const MainMenu = () => {
    const { locale } = useContext(LocaleContext);
    return (
        <StaticQuery
            query={graphql`
          query {
            contentfulMenu(type: { eq: "Main Menu" }) {
                    menuItem {
                      id
                      svLinkTitle
                      enLinkTitle
                      fiLinkTitle
                      slug
                    }
                    svSocialMediaItems {
                      id
                      titel
                      url
                    }
                    enSocialMediaItems {
                      id
                      titel
                      url
                    }
                    fiSocialMediaItems {
                      id
                      titel
                      url
                    }
                  }
                
          }
        `}
            render={data => {
                const mainMenu = data.contentfulMenu;
                const socialMediaMenu = getLocalizedPropertyByPrefix(mainMenu, 'SocialMediaItems', locale);
                return (
                    <Fragment>
                        <ul className="main-menu">
                            {mainMenu.menuItem.map(item => (
                                <li key={item.id}>
                                    <LocalizedLink
                                        to={item.slug}
                                        className="menu-item"
                                        activeClassName="active"
                                    >
                                        { getLocalizedPropertyByPrefix(item, 'LinkTitle', locale) }
                                    </LocalizedLink>
                                </li>
                            ))}
                        </ul>
                        <ul className="social-menu">
                            {socialMediaMenu.map(item => (
                                <li key={item.id}>
                                    <a
                                        href={item.url}
                                        className="menu-item"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {item.titel}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </Fragment>
                )
            }}
        />
    );
}

export default MainMenu;
